import OverviewPage from "@/views/overview/OverviewPage.vue";

const overviewRoutes = [  
  {
    path: "",
    children: [
        {
        path: "overview",
        name: "OverviewPage",
        component: OverviewPage,
        },
    ],
  },
];


export default overviewRoutes;